import React from 'react'
import './Location.css'

const Location = () => {
  return (
    <div className="location-container" id='OnSom'>
      <h1>ON SOM</h1>
      <div className='location'> 
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2984.502948949606!2d1.6146803878395593!3d41.58000101434782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a469e62e8371a7%3A0xf269d1f80f6f8fbe!2sEquips%20Oficina%20Anoia!5e0!3m2!1sca!2ses!4v1724851282410!5m2!1sca!2ses" style ={{width: '1200px', height: '700px'}}></iframe>
      </div>
      
    </div>
  )
}

export default Location
